const geocodeLatLng = (
    latitude: number,
    longitude: number
): Promise<google.maps.GeocoderResult> => {
    const latLng = new window.google.maps.LatLng(latitude, longitude);
    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve, reject) => {
        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === 'OK' && results && results.length > 0) {
                const addressComponents = results[0].address_components;
                const city = addressComponents.find(
                    (component) => component.types.includes('locality')
                )?.long_name;

                const state = addressComponents.find(
                    (component) =>
                        component.types.includes('administrative_area_level_1')
                )?.short_name;

                if (city && state) {
                    resolve(results[0]);
                } else {
                    reject('City and state not found');
                }
            } else {
                reject('Geocoding failed');
            }
        });
    });
};

const slugify = (text: string): string =>
  text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-');

export { geocodeLatLng, slugify };

